import { inject } from 'tsyringe'
import { containerScoped } from '~/decorators/dependency-container'
import RequestBuilder from '~/builders/http/RequestBuilder'
import { FieldValues } from '~/models/classified/form'
import { CategoryId } from '~/models/category/types'
import { Pagination } from '~/models/search/types'
import {
  IncompleteClassified,
  IncompleteClassifiedsFiltersCategoryOption
} from '~/models/classified/incomplete'

@containerScoped()
export default class IncompleteClassifiedService {
  constructor(@inject(RequestBuilder) private requestBuilder: RequestBuilder) {}

  submitIncompleteClassified({
    form,
    categoryId
  }: {
    form: FieldValues
    categoryId: CategoryId
  }): Promise<{ incompleteClassified: FieldValues }> {
    return this.requestBuilder
      .request('post', `/api/incomplete-classifieds/${categoryId}/submit/`)
      .data({
        form
      })
      .send()
  }

  getIncompleteClassifieds(
    params: { pg?: number; category?: number } = {}
  ): Promise<{
    incompleteClassifieds: {
      pagination: Pagination
      rows: IncompleteClassified[]
    }
    filters: {
      category: {
        options: IncompleteClassifiedsFiltersCategoryOption[]
      }
    }
  }> {
    return this.requestBuilder
      .request('get', `/api/incomplete-classifieds/`)
      .params(params)
      .send()
  }

  deleteIncompleteClassified(id: number): Promise<{ message: string }> {
    return this.requestBuilder
      .request('delete', `/api/incomplete-classified/${id}/`)
      .send()
  }
}
